import { Injectable } from '@angular/core';
import { Route, Router } from '@angular/router';
import { MenuItem } from '../Models/menuItem';
import { MasterPageComponent } from '../master/masterpage.component';
import { AuthorizationCheck } from '../auth/authorizationCheck';
import { menuComponentFromTo, MenuModelFromTo } from '../Models/menuComponentFromTo';
import { NotFoundPageComponent } from '../master/components/not-found-page/not-found-page.component';

@Injectable({ providedIn: 'root'})
export class DynamicMenuService {

  routerArr = this.router.config;
  menuComponent: MenuModelFromTo[] = menuComponentFromTo;
  DEFAULT_ROUTE: Route = { path: '**', component: NotFoundPageComponent };

  constructor(private router: Router) { }

  setRouteMenu(menuItems: MenuItem[]) {

    const paths = this.router.config.map( route => route.path);
    if (paths.includes('**')) {
      this.router.config.splice(paths.indexOf('**'), 1);
    }

    menuItems.forEach((item) => {
      const url = this.menuComponent.find(m => m.urlMenu === item.url);
      if (url !== undefined) {
        if (item.url && item.url.indexOf('.aspx') > -1) {
          this.routerArr.push(
            {
              path: url.routeMenu,
              component: MasterPageComponent,
              children: [{ outlet: 'master', path: '', component: url.componentMenu }],
              canActivate: [AuthorizationCheck], runGuardsAndResolvers: 'always'
            }
          );
        }
      }
      if (item.children && item.children.length > 0) {
        this.setRouteMenu(item.children);
      }
    });
    
    this.router.resetConfig(this.routerArr);
    this.router.config.push(this.DEFAULT_ROUTE);
  }
}
